export const contractSections = [
  { id: "branding", label: "Branding" },
  { id: "parties", label: "Parties" },
  { id: "engagement", label: "Engagement" },
  { id: "scope", label: "Scope" },
  { id: "payment", label: "Payment" },
  { id: "legal", label: "Legal" },
  { id: "signatures", label: "Signatures" },
];

export const defaultContract = () => ({
  contractType: "consulting",
  contractTitle: "Consulting Services Agreement",
  documentColor: "#fff5f5",
  fontColor: "#202020",
  accentColor: "#c24a4a",
  brandNameStyle: "serif",
  brandLogo: "",
  consultantBusiness: "Northstar Consulting",
  consultantName: "Your Name",
  consultantAddress: "123 Founder Street\nLondon, United Kingdom",
  consultantEmail: "hello@example.co.uk",
  consultantPhone: "+44 7000 000000",
  consultantWebsite: "yourwebsite.com",
  clientBusiness: "Client Company Ltd",
  clientName: "Client Name",
  clientAddress: "Client address\nUnited Kingdom",
  clientEmail: "client@example.co.uk",
  effectiveDate: new Date().toISOString().slice(0, 10),
  projectName: "Strategic consulting engagement",
  purpose: "The consultant will provide professional advisory and implementation support to help the client clarify priorities, improve operations, and complete the agreed project deliverables.",
  objectives: "Clarify project goals\nCreate a practical delivery roadmap\nProvide expert recommendations\nSupport implementation through agreed review sessions",
  scopeOfWork: "Discovery session and requirements review\nStrategy recommendations and written summary\nImplementation support and stakeholder check-ins\nFinal review call and handover notes",
  deliverables: "Project roadmap — due within 7 business days\nRecommendation report — due within 14 business days\nFinal handover notes — due at project completion",
  outOfScope: "Legal, tax, accounting, regulated financial advice, paid media spend, third-party software fees, and work not described in the agreed scope are excluded unless confirmed in writing.",
  startDate: new Date().toISOString().slice(0, 10),
  endDate: "",
  term: "This agreement begins on the effective date and continues until the deliverables are completed, unless terminated earlier under the termination clause.",
  feeStructure: "Fixed project fee",
  feeAmount: "£2,500 plus VAT if applicable",
  paymentSchedule: "50% deposit due before work starts and 50% due on delivery of the final handover notes.",
  latePayment: "Late payments may pause work and may be subject to reasonable interest or recovery costs permitted by applicable law.",
  expenses: "Pre-approved project expenses will be invoiced separately at cost.",
  clientResponsibilities: "Provide timely information, access, feedback, and approvals\nNominate one main point of contact\nReview deliverables within five business days\nMake payments according to the agreed schedule",
  confidentiality: "Both parties agree to protect confidential information received during the engagement and to use it only for purposes connected with this agreement.",
  intellectualProperty: "Unless otherwise agreed, the client owns final paid deliverables after full payment. The consultant retains ownership of pre-existing tools, templates, frameworks, methods, and know-how.",
  independentContractor: "The consultant acts as an independent contractor and is not an employee, partner, agent, or joint venture of the client.",
  termination: "Either party may terminate this agreement with 14 days written notice. The client remains responsible for fees and approved expenses incurred up to the termination date.",
  liability: "To the fullest extent permitted by law, each party's liability is limited to the fees paid or payable under this agreement, except for fraud, wilful misconduct, confidentiality breaches, or liabilities that cannot legally be limited.",
  governingLaw: "England and Wales",
  notices: "Official notices should be sent by email and, where appropriate, confirmed in writing to the contact details listed in this agreement.",
  signatureDate: new Date().toISOString().slice(0, 10),
  consultantSignatureName: "Your Name",
  consultantSignatureTitle: "Consultant / Founder",
  consultantSignatureDate: new Date().toISOString().slice(0, 10),
  consultantSignatureImage: "",
  clientSignatureName: "Client Name",
  clientSignatureTitle: "Authorised Representative",
  clientSignatureDate: new Date().toISOString().slice(0, 10),
  clientSignatureImage: "",
  disclaimer: "This document is a practical contract template and is not legal advice. Consider professional legal review before signing.",
});